import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { API, graphqlOperation } from "aws-amplify";

// Actions
import { TOGGLE_CREATE_MENU } from "../actions/ActionTypes";

// Components
import {
  Container,
  ButtonToolbar,
  ButtonGroup,
  Form,
  Button,
  Row,
} from "react-bootstrap";
import QRElement from "../Components/QRElement";
import { me } from "../graphql/queries";
import { IMAGES } from "../constants";

const MenuLink = ({ menus, history, dispatch, restaurant, match }) => {
  const { menuPath } = match.params;
  const [restaurantUrl, setRestaurantUrl] = useState("");
  const [userDisabled, setUserErr] = useState(false);

  useEffect(() => {
    if (restaurant?.restaurantUrl && menus?.length > 0) {
      setRestaurantUrl(
        `${restaurant.restaurantUrl}${menuPath ? `/#/${menuPath}` : ""}`
      );
    } else {
      // If there's no restaurantUrl (it shouldn't happens) then get the menuUrl
      if (menus && menus[0]?.menuUrl) {
        setRestaurantUrl(menus[0].menuUrl);
      }
    }
  }, [menus, restaurant, menuPath]);

  useEffect(() => {
    const getUserEnabled = async () => {
      try {
        const { data } = await API.graphql(graphqlOperation(me));
        if (data && data.me && !data.me.enabled) {
          setUserErr(true);
        }
      } catch (error) {
        console.log(error);
      }
    };
    getUserEnabled();
  }, []);

  function goBack() {
    history.push("/menus-list");
  }

  function goUploadMenu() {
    dispatch({ type: TOGGLE_CREATE_MENU });
  }

  /**
   * Downloads the QR code that we generate to the canvas.
   *
   * Taken from:
   * https://stackoverflow.com/questions/51945711/unable-to-download-react-canvas-drawing
   *
   * Removed 'canvas' and 'url' as they weren't actually being used. The only needed code
   * is the bit below.
   */
  function downloadQr() {
    var link = document.createElement("a");
    link.download = formatRestaurantName() + ".png";
    link.href = document.getElementById("canvas").toDataURL();
    link.click();
  }

  function formatRestaurantName() {
    return restaurant?.name.toLowerCase().replace(/ /g, "_").replace(/'/g, "");
  }

  return (
    <>
      {restaurantUrl ? (
        <Container fluid className="wrapper px-0">
          <Row className="mx-0">
            {userDisabled ? (
              <p className="error-message mt-2 px-5">
                Account was disabled. Please contact our support team to{" "}
                <strong>
                  <a href="mailto: support@bluecart.com">
                    support@bluecart.com
                  </a>
                </strong>
              </p>
            ) : (
              <div className="w-100">
                <div className="px-5">
                  <h3 className="title-setting mb-4">
                    Great news, your digital menu has been published!
                  </h3>
                  <Form.Group controlId="formMenuDescription" className="mb-0">
                    <Form.Label className="menu-link-label">
                      Use this link:
                    </Form.Label>
                  </Form.Group>

                  <a
                    href={restaurantUrl}
                    className="menu-url"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {restaurantUrl}
                  </a>

                  <p className="mt-3 menu-label-qr">
                    or scan the QR below to open it.
                  </p>
                  <div className="text-center">
                    <QRElement
                      url={restaurantUrl}
                      displayLogoInQRCode={restaurant?.displayLogoInQRCode}
                      logoKey={restaurant?.logoKey}
                      logoPreviewFile={restaurant?.logoPreviewFile}
                    />
                  </div>
                </div>

                <hr />
                <ButtonToolbar
                  aria-label="Toolbar with button groups"
                  className="justify-content-center pt-4"
                >
                  <ButtonGroup className="mr-4" aria-label="Second group">
                    <Button
                      variant="outline-dark"
                      className="menu-link-button goback-button"
                      onClick={goBack}
                    >
                      Go back
                    </Button>
                  </ButtonGroup>
                  <ButtonGroup aria-label="Third group">
                    <Button
                      variant="dark"
                      onClick={downloadQr}
                      className="download-template add-menu-button"
                    >
                      Download QR
                      <img
                        src={IMAGES.DOWNLOAD_ICON}
                        alt="download"
                        height={22}
                        width={22}
                      />
                    </Button>
                  </ButtonGroup>
                </ButtonToolbar>
              </div>
            )}
          </Row>
        </Container>
      ) : (
        <div className="wrapper">
          <h3 className="title-setting mb-4">Please publish a menu first</h3>
          <ButtonGroup className="mr-2" aria-label="Second group">
            <Button
              variant="outline-dark"
              onClick={goUploadMenu}
              className="menu-link-button"
            >
              Upload Menu
            </Button>
          </ButtonGroup>
        </div>
      )}
    </>
  );
};

MenuLink.propTypes = {
  restaurant: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  dispatch: PropTypes.func.isRequired,
  menus: PropTypes.array.isRequired,
  match: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  menus: state.menu.menus,
  restaurant: state.restaurant.restaurant,
});

export default connect(mapStateToProps)(MenuLink);
